<template>
  <v-layout column>
    <h3>{{ editMode ? "Update Parking / Toll" : "Create new Parking / Toll" }}</h3>
    <v-flex align-center justify-center>
      <form>
        <v-text-field
          v-model="form.name"
          :error-messages="nameErrors"
          label="Name"
          required
          maxlength="60"
          @input="$v.form.name.$touch()"
          @blur="$v.form.name.$touch()"
        ></v-text-field>
        <v-switch v-model="form.chargeCommission" label="       Charge Commission" required></v-switch>
        <v-switch v-model="form.enabled" label="       Enabled" required></v-switch>
        <v-text-field
          class="mt-2"
          v-model="form.amount"
          :rules="[monetaryValueValidator]"
          label="Amount"
          autofocus
          prefix="£"
        ></v-text-field>
        <v-btn v-if="area == null" @click="addRegion">Add Region</v-btn>
        <v-flex pt-3 pb-4 pl-2>
          <v-layout row>
            <AreaPolygonMap ref="areaMap"></AreaPolygonMap>
          </v-layout>
        </v-flex>
        <v-btn
          class="text-none"
          large
          color="green lighten-2"
          dark
          @click="submit"
        >{{ editMode ? "Update" : "Create" }}</v-btn>
      </form>
    </v-flex>
  </v-layout>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";

import LocationInput from "@/components/widget/input/LocationInput.vue";
import AreaPolygonMap from "@/components/widget/AreaPolygonMap.vue";
// import { setTimeout } from "timers";

export default {
  name: "location_cost_area_details",
  components: {
    LocationInput,
    AreaPolygonMap
  },
  props: {
    loading: { type: Boolean, default: false },
    editMode: { type: Boolean, default: false },
    locationAdditionalChargeDetails: { type: Object, default: null }
  },
  data: function() {
    return {
      pickupLocation: { id: null },
      destinationLocation: { id: null },
      drawingManager: null,
      form: {
        name: "",
        enabled: true,
        chargeCommission: true,
        amount: 0,
        region: null,
      },
      map: null,
      area: null,
      monetaryValueValidator: (v) =>
        /^\d+\.?\d?\d?$/.test(v) || "Please enter a valid amount",
    };
  },
  validations: {
    form: {
      name: { required },
      nameForCustomer: { required }
    }
  },
  beforeMount: function() {
    if (this.locationAdditionalChargeDetails != null) {
      this.form.name = this.locationAdditionalChargeDetails.name;
      this.form.chargeCommission = this.locationAdditionalChargeDetails.chargeCommission;
      this.form.enabled = this.locationAdditionalChargeDetails.enabled;
      this.form.amount = (this.locationAdditionalChargeDetails.amount / 100).toFixed(2);
    }
  },
  mounted: function() {
    var populatePolygons = this.populatePolygons;

    // TODO dont set timeout, actually wait for the map to load using a callback!
    setTimeout(function() {
      populatePolygons();
    }, 500);
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.form.name.$dirty) return errors;
      !this.$v.form.name.required && errors.push("Name is required.");
      return errors;
    },
    nameForCustomerErrors() {
      const errors = [];
      if (!this.$v.form.nameForCustomer.$dirty) return errors;
      !this.$v.form.nameForCustomer.required &&
        errors.push("Name for customer is required.");
      return errors;
    }
  },
  methods: {
    submit: function() {
      this.form.region = this.coordsToServerCoordinateFormat(this.area);

      this.$emit("submitted", this.form);
    },
    coordsToServerCoordinateFormat: function(polygon) {
      var serverCoordinates = [];

      for (var i = 0; i < polygon.getPath().getLength(); i++) {
        serverCoordinates.push([
          polygon
            .getPath()
            .getAt(i)
            .lat(),
          polygon
            .getPath()
            .getAt(i)
            .lng()
        ]);
      }

      serverCoordinates.push([
        polygon
          .getPath()
          .getAt(0)
          .lat(),
        polygon
          .getPath()
          .getAt(0)
          .lng()
      ]);

      return serverCoordinates;
    },
    addRegion() {

      var self = this;
      if (this.drawingManager == null) {

        console.log("Add Region");

        this.drawingManager = new google.maps.drawing.DrawingManager({
          drawingMode: google.maps.drawing.OverlayType.POLYGON,
          drawingControl: true,
          drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
            drawingModes: ["polygon"]
          },
          polygonOptions: {
            editable: true,
            strokeColor: this.selectedColor
          }
        });

        var drawingManager = this.drawingManager;

        google.maps.event.addListener(
          this.drawingManager,
          "overlaycomplete",
          function(event) {
            event.overlay.set("editable", true);
            event.overlay.set("draggable", true);
            drawingManager.setMap(null);
            console.log(event.overlay);

            self.area = event.overlay;
          }
        );

        this.drawingManager.setMap(this.$refs.areaMap.map);
      }
    },
    addPolygon: function(coords, polygon, color) {
      if (polygon != null) {
        polygon.setMap(null);
      }

      polygon = new google.maps.Polygon({
        paths: coords,
        editable: true,
        draggable: true,
        strokeColor: color
      });

      console.log(this.$refs.areaMap.map);
      polygon.setMap(this.$refs.areaMap.map);

      console.log("Restored polygon");

      return polygon;
    },
    populatePolygons: function() {

      if (this.locationAdditionalChargeDetails == null) {
        return;
      }
      
      console.log("Populating Polygons");

      var bounds = new google.maps.LatLngBounds();

      var pickupCoords = [];
      var pickupPolygonJSON = this.locationAdditionalChargeDetails.region;

      for (var i = 0; i < pickupPolygonJSON.length; i++) {
        pickupCoords.push({
          lat: pickupPolygonJSON[i][0],
          lng: pickupPolygonJSON[i][1]
        });

        bounds.extend({
          lat: pickupPolygonJSON[i][0],
          lng: pickupPolygonJSON[i][1]
        });
      }

      this.area = this.addPolygon(
        pickupCoords,
        this.locationAdditionalChargeDetails.area,
        "#FF0000"
      );

      this.$refs.areaMap.map.fitBounds(bounds);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.v-label {
  padding-left: 8px;
}
</style>
